module.exports = __webpack_public_path__ + "static/media/Features 6.4b091609.svg";